import React, { Component } from "react";
import responsibleIllust from "../images/featureResponsible_illust.jpg";

class FeatureResponsible extends Component {
	constructor() {
		super();

		this.introAnim = this.introAnim.bind(this);
		this.outroAnim = this.outroAnim.bind(this);
	}

	componentDidMount() {
		document.addEventListener("camDone", this.introAnim);
		document.addEventListener("stateWillChange", this.outroAnim);
	}

	componentWillUnmount() {
		document.removeEventListener("camDone", this.introAnim);
		document.removeEventListener("stateWillChange", this.outroAnim);
	}

	introAnim(e) {
		if (!e.detail.state || e.detail.state.name !== "FEATURE_RESPONSIBLE") return;

		setTimeout(() => {
			const slideDiv = document.querySelector(".slide");
			this.fadeDivs = [...slideDiv.querySelectorAll(".fade-init")];
			this.heroImg.classList.add("swipe-reveal");
			setTimeout(() => {
				this.featureDiv.classList.add("swipe-reveal");
				this.fadeDivs.map((f) => f.classList.remove("fade"));
			}, 400);
		}, 100);
	}

	outroAnim(e) {
		if (e.detail.newState && e.detail.newState.name === "FEATURE_RESPONSIBLE") return;
		const swipeOuts = [...document.querySelectorAll(".swipe-init")];
		const fadeOuts = [...document.querySelectorAll(".fade-init")];
		swipeOuts.map((s) => {
			s.classList.add("swipe-out");
		});
		fadeOuts.map((f) => {
			f.classList.add("fade");
		});
	}

	render() {
		return (
			<div className="slide feature-slide clickable">
				<div className="slide-close-container">
					<div
						className="slide-close"
						onClick={() => {
							this.props.GoToState("OVERVIEW");
						}}
					></div>
				</div>
				<div className="feature-slide-wrapper">
					<div
						className="feature-slide-container swipe-init"
						ref={(ref) => (this.featureDiv = ref)}
					>
						<div className="enlarge-button feature-button"></div>
						<div
							className="feature-img-block"
							style={{ backgroundImage: `url(${responsibleIllust})` }}
						></div>
						<ul className="feature-list w-list-unstyled">
							<li className="feature-item-title">
								<div className="feature-title">BREEAM 'Excellent'</div>
								<div className="feature-copy">
									Internationally recognised third party certification of the
									sustainability performance of the building
								</div>
							</li>

							<li className="feature-item-title">
								<div className="feature-title">EPC A</div>
								<div className="feature-copy">
									Highest energy performance certification rating
								</div>
							</li>

							<li className="feature-item-title">
								<div className="feature-title">Low VOC Products</div>
								<div className="feature-copy">Improving indoor air quality</div>
							</li>

							<li className="feature-item-title">
								<div className="feature-title">Green Spaces</div>
								<div className="feature-copy">
									34% of the buildings external areas are made of Green Space.
								</div>
							</li>

							<li className="feature-item-title">
								<div className="feature-title">
									Efficient Construction Practices
								</div>
								<div className="feature-copy">
									Reduced construction waste and diversion from landfill
								</div>
							</li>

							<li className="feature-item-title">
								<div className="feature-title">Better Operating Efficiency</div>
								<div className="feature-copy">
									Reduction in operational water consumption and energy use
								</div>
							</li>
						</ul>
						<div className="feature-vert-title">
							<div className="title-vert-rotate">
								<h2 className="h2 feature-vert">Responsible Space</h2>
							</div>
						</div>
					</div>
				</div>
				<div className="feature-slide-main">
					<div
						ref={(ref) => (this.heroImg = ref)}
						className="feature-slide-image swipe-init"
						style={{
							backgroundImage: `url(./images/gallery/ter1.jpg)`,
							backgroundSize: "cover",
						}}
					></div>
				</div>
			</div>
		);
	}
}

export default FeatureResponsible;
